const net = require("net");
const Printer = require("./printer");


module.exports = class printerZPL {
    async printLabel(obj) {
      if (!obj || !obj.options) {
        throw new Error(
          "O parâmetro necessário não foi repassado corretamente, por favor revise as instruções."
        );
      }
  
      const zplCode = `^XA
  
      ^CFA,30
      ^FO50,300^FDJohn Doe^FS
      ^FO50,340^FD100 Main Street^FS
      ^FO50,380^FDSpringfield TN 39021^FS
      ^FO50,420^FDUnited States (USA)^FS
      
      ^XZ`;
  
      return this.print(obj.options, zplCode);
    }
  
    print(options, zplCode) {
      if (
        options.printerType &&
        options.printerType === 'N'
      ) {
        if (!options.printerAddress) {
          throw new Error(
            "O endereço da impressora não foi informado, por favor reveja as instruções."
          );
        }
  
        options.printerPort = options.printerPort || 9100;
        options.timeout = options.timeout || 30000;
  
        return new Promise(async (resolve) => {
          var printer = await net.connect({
            host: options.printerAddress,
            port: options.printerPort,
            timeout: options.timeout,
          });
  
          printer.write(Buffer.from(zplCode), null, function () {
            resolve("Dados enviados para a impressora");
            printer.destroy();
          });
  
          printer.on("error", function (error) {
            resolve(false);
            printer.destroy();
            throw new Error("Erro de conexão com a impressora: ", error);
          });
  
          printer.on("timeout", function () {
            resolve(false);
            printer.destroy();
            throw new Error("Timeout durante a conexão com a impressora: ");
          });
        });
      } else {
        if (!options.printerName) {
          throw new Error(
            "O nome da impressora não foi informado. Reveja as instruções de uso."
          );
        }
  
        try {
          const printers = Printer.list();
          let printerFound = false;
  
          if (!printers) {
            throw new Error(
              "Não foi possível ler a lista de impressoras instaladas."
            );
          }
  
          printers.map((printer) => {
            if (printer === options.printerName) {
              printerFound = true;
            }
          });
  
          if (!printerFound) {
            throw new Error("A impressoa informada não está instalada.");
          }
  
          const printer = new Printer(options.printerName);
  
          return printer.printRaw(zplCode);
        } catch (err) {
          throw new Error(err);
        }
      }
    }
}